import { render, staticRenderFns } from "./publicModel.vue?vue&type=template&id=6bd5d7d7&scoped=true&"
import script from "./publicModel.vue?vue&type=script&lang=js&"
export * from "./publicModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd5d7d7",
  null
  
)

export default component.exports